<!-- Solo vive dentro de «Nueva solicitud» (12/10/2026): el encabezado,
     «Regresar» y «Pedir mantenimiento» los pone el concentrador. -->
<div class="mnt mism">
  <!-- ==================== Esperan tu visto bueno ====================
       Lo único que le toca hacer a quien pidió. Va primero y en ámbar,
       como la bandeja de Permisos: «pide atención» sin gritar. -->
  <section class="table-page__card mism-vobo" *ngIf="porConfirmar.length">
    <div class="mism-vobo__cab">
      <span class="material-icons" aria-hidden="true">notifications_active</span>
      <h2 class="mism-seccion">
        <b>{{ porConfirmar.length }}</b>
        {{ porConfirmar.length === 1 ? 'solicitud espera' : 'solicitudes esperan' }} tu visto bueno
      </h2>
    </div>
    <ul class="mism-vobo__lista">
      <li *ngFor="let s of porConfirmar; trackBy: trackSol">
        <span class="mnt-cat" aria-hidden="true"><span class="material-icons">{{ cat(s).icono }}</span></span>
        <div class="mism-vobo__txt">
          <b>{{ s.folio }}<ng-container *ngIf="cat(s).texto"> · {{ cat(s).texto }}</ng-container></b>
          <span>{{ s.ubicacion ? s.ubicacion + ' · la resolvió' : 'La resolvió' }} {{ s.responsable || 'mantenimiento' }}</span>
        </div>
        <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="abrir(s.idSolicitud)">
          <span class="material-icons" aria-hidden="true">fact_check</span>
          Revisar
        </button>
      </li>
    </ul>
  </section>

  <!-- ==================== Tus solicitudes ==================== -->
  <section class="table-page__card">
    <div class="mism-cab">
      <h2 class="mism-seccion">Tus solicitudes</h2>
      <span class="mism-cuenta" *ngIf="abiertas">{{ abiertas }} {{ abiertas === 1 ? 'abierta' : 'abiertas' }}</span>
      <!-- Sin encabezado propio, la bandeja de quien atiende se ofrece aquí. -->
      <a class="app-form-btn app-form-btn--secondary app-form-btn--compact mism-cab__ir" *ngIf="puedeAtender"
         [routerLink]="['/admin/mantenimiento/gestion']">
        <span class="material-icons" aria-hidden="true">engineering</span>
        Atención de mantenimiento
      </a>
    </div>

    <div class="table-page__table-wrap" *ngIf="lista.length; else vacio">
      <table class="table-page__table mism-tabla">
        <thead>
          <tr>
            <th>Solicitud</th>
            <th>Asunto</th>
            <th>Estatus</th>
            <th>Atiende</th>
            <th class="table-page__actions-head">Ver</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of paginaActual(); trackBy: trackSol" class="is-clickable" (click)="abrir(s.idSolicitud)" (keydown.enter)="$event.target === $event.currentTarget ? abrir(s.idSolicitud) : null">
            <td>
              <div class="mism-sol">
                <span class="mnt-cat" aria-hidden="true"><span class="material-icons">{{ cat(s).icono }}</span></span>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ s.folio }}</strong>
                  <span class="table-page__subtext"><ng-container *ngIf="cat(s).texto">{{ cat(s).texto }} · </ng-container>{{ dia(s.fechaSolicitud) }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack mism-que">
                <span class="table-page__text mism-donde" *ngIf="s.ubicacion">{{ s.ubicacion }}</span>
                <span class="mism-desc" [ngClass]="s.ubicacion ? 'table-page__subtext' : 'table-page__text'">{{ s.descripcion }}</span>
              </div>
            </td>
            <td>
              <span class="mnt-estatus" [ngClass]="est(s).clase">
                <span class="material-icons" aria-hidden="true">{{ est(s).icono }}</span>{{ est(s).texto }}
              </span>
            </td>
            <td><span class="table-page__text mism-quien">{{ quien(s) }}</span></td>
            <td class="table-page__actions">
              <button type="button" class="table-page__action-btn" (click)="$event.stopPropagation(); abrir(s.idSolicitud)"
                      title="Ver el detalle" aria-label="Ver el detalle">
                <span class="material-icons">visibility</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-page__footer" *ngIf="!cargando && totalPaginas() > 1">
      <div class="table-page__meta">Mostrando {{ rangoInicio() }} a {{ rangoFin() }} de {{ lista.length }}</div>
      <nav class="table-page__pager" aria-label="Paginación">
        <button type="button" class="table-page__pager-link" (click)="irPagina(pagina - 1)" [disabled]="pagina <= 1"
                title="Página anterior" aria-label="Página anterior">
          <span class="material-icons">chevron_left</span>
        </button>
        <button type="button" class="table-page__pager-page" *ngFor="let p of paginas()"
                [class.is-current]="p === pagina" (click)="irPagina(p)">{{ p }}</button>
        <button type="button" class="table-page__pager-link" (click)="irPagina(pagina + 1)" [disabled]="pagina >= totalPaginas()"
                title="Página siguiente" aria-label="Página siguiente">
          <span class="material-icons">chevron_right</span>
        </button>
      </nav>
    </div>

    <ng-template #vacio>
      <div class="table-page__empty" *ngIf="!cargando; else consultando">
        <span class="material-icons" aria-hidden="true">handyman</span>
        <h3>Todavía no has pedido mantenimiento</h3>
        <p>Si algo del edificio falla —luz, agua, aire, una silla, una chapa—, pídelo aquí.</p>
      </div>
    </ng-template>
    <ng-template #consultando>
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <p>Consultando…</p>
      </div>
    </ng-template>
  </section>
</div>
